import logo from "@/assets/sc_logo_marquee.png";

// Top navigation-only brand mark — same gold/blue art-deco marquee emblem
// used on public pages (nav, sign-in/up), so the brand mark matches whether
// a visitor is signed out or signed in.
export function NavLogo({ height, width, className = "" }) {
  const style = {};
  if (height != null) style.height = height;
  if (width != null) style.width = width;
  return <img src={logo} alt="Screening Circle" style={style} className={className} data-testid="nav-logo" />;
}
